<template>
  <div v-if="care_vital_sign.care_has_vital_signs.length > 0">
    <p
      :class="[
        'm-0 text-thirteen upper-text',
        item.description == 'PASTOSA' && 'color-orange',
        item.description == 'EM CÍBALOS' && 'color-orange',
        item.description == 'BEM MOLDADAS' && 'color-green',
        item.description == 'AUSENTE' && 'color-red',
        item.description == 'LÍQUIDA' && 'color-red',
      ]"
    >
      {{ item.description }}
    </p>
    <p class="mb-1 worksansr text-twelve upper-text">
      CADASTRADO POR: {{ item.user_name }}
    </p>
    <hr />
  </div>
</template>

<script>
export default {
  name: "Evacuacao",
  props: {
    care_vital_sign: Object,
    item: Object,
  },
};
</script>